/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useContext } from "react";
import { IDndRegistry } from "./DndTypes";

export interface IDndContext {
	contextId: string;
	registry: IDndRegistry;
}

export const DndContext = React.createContext<IDndContext>(null);

export function useDndContext(): IDndContext {
	return useContext(DndContext);
}
